import MDBox from "components/MDBox";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {
  Checkbox,
  Chip,
  Divider,
  Icon,
  Stack,
  Typography,
} from "@mui/material";
import MDButton from "components/MDButton";
import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DataTable from "examples/Tables/DataTable";
import Autocomplete from "@mui/material/Autocomplete";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import ApiCalls from "services/flick_erp_api_call";
import { useSelector, useDispatch } from "react-redux";
import { employeeList } from "layouts/employees/employeesSlice";
import MDTypography from "components/MDTypography";
import { SelectEmployee } from "components/SelectEmployee";
import moment from "moment";
import rgba from "assets/theme/functions/rgba";
import { getNextDay, getNextDate } from "helpers/DateTime";
import colors from "assets/theme/base/colors";
import { CalendarMonth, EventRepeat, Groups, TimerSharp } from "@mui/icons-material";

const panelCardSx = {
  //borderRadius: "28px",
  border: `1px solid ${colors.grey[200]}`,
  boxShadow: "0 20px 50px rgba(15, 23, 42, 0.07)",
  overflow: "hidden",
  background: colors.white.main,
};

const dialogPaperSx = {
  backgroundColor: colors.white.main,
  boxShadow: "0 30px 90px rgba(15, 23, 42, 0.16)",
  width: "720px",
  maxWidth: "calc(100vw - 32px)",
  borderRadius: "28px",
  border: `1px solid ${colors.grey[200]}`,
};

const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "16px",
    backgroundColor: "#fbfcfe",
  },
};

const statCard = (icon, label, value, accent) => ({
  icon,
  label,
  value,
  accent,
});

const initialCreatePayload = () => ({
  request: "create",
  start_date: new Date()
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-"),
});

const getEmployeeMetaLabel = (employee) => {
  const designation = employee?.designation;
  const department = employee?.department;

  if (typeof designation === "string" && designation.trim()) return designation;
  if (designation?.name) return designation.name;
  if (typeof department === "string" && department.trim()) return department;
  if (department?.name) return department.name;

  return "Assigned employee";
};

function Shifts() {
  const dispatch = useDispatch();
  const [officeShifts, setOfficeShifts] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [employeeChecked, setEmployeeChecked] = useState(false);
  const [ShiftError, setShiftError] = useState("");
  const [ShiftHoursError, setShiftHoursError] = useState("");
  const [StartTimeError, setStartTimeError] = useState("");
  const [StartDateError, setStartDateError] = useState("");
  const [EndDateError, setEndDateError] = useState("");
  const [SelectEmployeError, setSelectEmployeError] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [SelectWeeklyOffError, setSelectWeeklyOffError] = useState("");
  const [editPayloadData, setEditPayloadData] = useState({});
  const [multiDialogOpen, setMultiDialogOpen] = useState(false);
  const [editDialog, setEditDialog] = useState(false);
  const [dateColumn, setDateColumn] = useState({
    days: Array.from(Array(7).keys()),
    date: new Date().getDate(),
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  });

  const [selectedMonth, setSelectedMonth] = useState(
    `${new Date().getFullYear()}-${new Date().toLocaleString("en-GB", {
      month: "2-digit",
    })}`
  );

  const weekList = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const [shiftPayload, setShiftPayload] = useState(initialCreatePayload());

  const [employeeShiftsData, setEmployeeShiftsData] = useState({
    columns: [],
    rows: [],
  });

  const employees = useSelector((state) => state.employee.employee);
  const selectedShiftDetails = officeShifts.find((shift) => shift.id == shiftPayload.shift);
  const editShiftDetails = officeShifts.find((shift) => shift.id == editPayloadData.shift);
  const totalEmployees = employees?.length || 0;
  const assignedEmployeesCount = selectedEmployee !== "" ? 1 : employeeShiftsData.rows.length;
  const selectedEmployeesCount =
    shiftPayload?.user_ids?.length || selectedEmployees.length || 0;

  const shiftTimeLabel = (timeFrom, timeTo, weekOff) => {
    if (weekOff) return "Week Off";
    if (timeFrom != undefined && timeTo != undefined) {
      return `${moment(timeFrom, "HHmmss").format("LT")} - ${moment(
        timeTo,
        "HHmmss"
      ).format("LT")}`;
    }
    return "";
  };

  const filterShiftDate = (shift, date) => {
    const data = shift?.find((entry) => entry?.date == date);
    return shiftTimeLabel(data?.time_from, data?.time_to, data?.week_off);
  };

  const buildNameCell = (row) => (
    <Stack spacing={0.35}>
      <MDTypography variant="button" fontWeight="medium" color="dark">
        {row?.original?.user?.firstname} {row?.original?.user?.lastname}
      </MDTypography>
      <MDTypography variant="caption" color="text">
        {getEmployeeMetaLabel(row?.original)}
      </MDTypography>
    </Stack>
  );

  const resetCreateDialog = () => {
    setMultiDialogOpen(false);
    setShiftPayload(initialCreatePayload());
    setSelectedEmployees([]);
    setEmployeeChecked(false);
  };

  const handleSubmit = async () => {
    if (shiftPayload.shift == undefined) {
      setShiftError("Please select the shift");
    } else {
      setShiftError("");
    }
    if (shiftPayload.start_date == undefined) {
      setStartDateError("Please select the start date");
    } else {
      setStartDateError("");
    }
    if (shiftPayload.end_date == undefined) {
      setEndDateError("Please select the end date");
    } else {
      setEndDateError("");
    }
    if (shiftPayload.shift_hours == undefined) {
      setShiftHoursError("Please enter hours");
    } else {
      setShiftHoursError("");
    }
    if (shiftPayload.time_from == undefined) {
      setStartTimeError("Please enter start time");
    } else {
      setStartTimeError("");
    }
    if (shiftPayload.week_off == undefined || shiftPayload.week_off.length == 0) {
      setSelectWeeklyOffError("Please select at least one week day");
    } else {
      setSelectWeeklyOffError("");
      createShift();
    }
  };

  async function getEmployee() {
    const res = await ApiCalls.getBaseEmployeesList("?status=active");
    if (res.success && res.code === 200) {
      dispatch(employeeList({ employee: JSON.parse(JSON.stringify(res.data)) }));
    }
  }

  async function getEmployeeShifts(queryParams) {
    const res = await ApiCalls.getEmployeeShifts(queryParams);
    if (res.success && res.code === 200 && employees) {
      const empShift =
        selectedEmployee != ""
          ? [
              {
                ...employees.find((employee) => employee.id == selectedEmployee),
                shift: res.data.filter((entry) => entry.employee == selectedEmployee),
              },
            ]
          : employees.map((employee) => ({
              ...employee,
              shift: res.data.filter((entry) => entry.employee == employee.id),
            }));

      setEmployeeShiftsData({
        columns: [
          {
            Header: "Name",
            accessor: "name",
            Cell: ({ row }) => buildNameCell(row),
          },
          ...dateColumn.days.map((_, index) => ({
            Header: getNextDate(
              index,
              dateColumn.date,
              dateColumn.month,
              dateColumn.year
            ),
            sub_header: getNextDay(
              index,
              dateColumn.date,
              dateColumn.month,
              dateColumn.year
            ),
            Cell: ({ column, row }) => {
              const currentShift = row?.original?.shift?.find(
                (entry) => entry?.date == column.Header
              );
              const displayValue = filterShiftDate(row?.original?.shift, column.Header);
              const isWeekOff = displayValue === "Week Off";

              return (
                <MDBox
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    minHeight: "46px",
                    px: 1.25,
                    py: 0.9,
                    borderRadius: "14px",
                    cursor: currentShift ? "pointer" : "default",
                    border: displayValue && `1px solid ${colors.grey[200]}`,
                    background: isWeekOff
                      ? "rgba(239, 68, 68, 0.08)"
                      : displayValue
                      ? "rgba(37, 99, 235, 0.06)"
                      : '',
                    transition: "all 180ms ease",
                    "&:hover": currentShift
                      ? {
                          transform: "translateY(-1px)",
                          boxShadow: "0 10px 22px rgba(15, 23, 42, 0.08)",
                          borderColor: colors.info.main,
                        }
                      : {},
                  }}
                  onClick={() => {
                    if (!currentShift) return;
                    setEditDialog(true);
                    setEditPayloadData(currentShift);
                  }}
                >
                  <MDTypography
                    variant="caption"
                    fontWeight="medium"
                    sx={{
                      //color: isWeekOff
                      //  ? colors.error.main
                      //  : displayValue
                      //  ? colors.dark.main
                      //  : colors.text.main,
                    }}
                  >
                    {displayValue || "-"}
                  </MDTypography>
                </MDBox>
              );
            },
          })),
        ],
        rows: empShift,
      });
    }
  }

  async function getOfficeShifts() {
    const res = await ApiCalls.getOfficeShifts();
    if (res.success && res.code === 200) {
      setOfficeShifts(res.data);
    }
  }

  async function createShift() {
    const data = {
      shift: shiftPayload.shift,
      shift_hours: shiftPayload.shift_hours,
      time_from: shiftPayload.time_from,
      start_date: shiftPayload.start_date,
      end_date: shiftPayload.end_date,
      week_off: shiftPayload.week_off,
      user_ids: shiftPayload.user_ids,
    };
    const res = await ApiCalls.createEmployeeShift(data, false);
    resetCreateDialog();
    if (res.success && res.code === 201) {
      getEmployeeShifts(
        `?${
          selectedEmployee != "" ? `employee_id=${selectedEmployee}` : ""
        }&month=${dateColumn.month + 1}&year=${dateColumn.year}&status=active`
      );
    }
  }

  async function updateEmployeeShift() {
    const data = {
      shift: editPayloadData.shift,
      shift_hours: editPayloadData.shift_hours,
      time_from: editPayloadData.time_from,
      is_wfh: editPayloadData.is_wfh,
			//tracking_method: editPayloadData.is_wfh ? editPayloadData.tracking_method : 0
    };
    await ApiCalls.updateShift(editPayloadData.id, data, false);
    setEditDialog(false);
    setEditPayloadData({});
    getEmployeeShifts(
      `?${
        selectedEmployee != "" ? `employee_id=${selectedEmployee}` : ""
      }&month=${dateColumn.month + 1}&year=${dateColumn.year}`
    );
  }

  function handleFilterSubmit() {
    setDateColumn({
      days: Array.from(
        Array(
          new Date(
            selectedMonth.split("-")[0],
            selectedMonth.split("-")[1],
            0
          ).getDate()
        ).keys()
      ),
      date: 1,
      month: selectedMonth.split("-")[1] - 1,
      year: selectedMonth.split("-")[0],
    });
  }

  useEffect(() => {
    getEmployee();
    getOfficeShifts();
  }, []);

  useEffect(() => {
    if (employees.length !== 0) {
      getEmployeeShifts(
        `?${
          selectedEmployee != "" ? `employee_id=${selectedEmployee}` : ""
        }&month=${dateColumn.month + 1}&year=${dateColumn.year}`
      );
    }
  }, [dateColumn, employees]);

  const stats = [
    statCard(
      <CalendarMonth sx={{ color: colors.info.main, mb: 1 }} fontSize="small" />,
      "Selected month",
      moment(`${selectedMonth}-01`).format("MMM YYYY"),
      "rgba(37, 99, 235, 0.08)"
    ),
    statCard(
      <Groups sx={{ color: colors.success.main, mb: 1 }} fontSize="small" />,
      "Employees",
      `${assignedEmployeesCount}/${totalEmployees}`,
      "rgba(16, 185, 129, 0.08)"
    ),
    statCard(
      <EventRepeat sx={{ color: colors.primary.main, mb: 1 }} fontSize="small" />,
      "Shift types",
      officeShifts.length,
      "rgba(124, 58, 237, 0.08)"
    ),
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={1} pb={3}>
        <MDBox mb={3}>
					<Card sx={panelCardSx}>
						<MDBox style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, margin: 20 }}>
							<MDBox sx={{ display: "flex", alignItem: "center", gap: 3 }}>
								<MDBox
									sx={{
										width: 48,
										height: 48,
										borderRadius: "16px",
										display: "grid",
										placeItems: "center",
										background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
										color: colors.white.main,
									}}
								>
									<TimerSharp />
								</MDBox>
								<MDBox>
									<MDTypography variant="h4">Shift Details</MDTypography>
									<MDTypography variant="body2" color="text">
										Review schedules, assign teams, and keep attendance planning organized.
									</MDTypography>
								</MDBox>
							</MDBox>
						</MDBox>
            {/*<MDBox
              sx={{
                px: { xs: 3, md: 4 },
                py: { xs: 3, md: 4 },
                background:
                  "linear-gradient(135deg, rgba(29, 78, 216, 0.08) 0%, rgba(14, 165, 233, 0.06) 55%, rgba(255, 255, 255, 1) 100%)",
              }}
            >
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} lg={7}>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <MDBox
                      sx={{
                        width: 58,
                        height: 58,
                        borderRadius: "20px",
                        display: "grid",
                        placeItems: "center",
                        background: "linear-gradient(135deg, #1d4ed8 0%, #0ea5e9 100%)",
                        color: colors.white.main,
                        boxShadow: "0 18px 40px rgba(29, 78, 216, 0.28)",
                      }}
                    >
                      <TimerSharp />
                    </MDBox>
                    <MDBox>
                      <MDTypography
                        variant="h3"
                        sx={{
                          color: colors.dark.main,
                          letterSpacing: "-0.03em",
                          lineHeight: 1.1,
                        }}
                      >
                        Shift Details
                      </MDTypography>
                      <MDTypography variant="body2" color="text" sx={{ mt: 1 }}>
                        Review schedules, assign teams, and keep attendance planning organized.
                      </MDTypography>
                    </MDBox>
                  </Stack>
                </Grid>
                <Grid item xs={12} lg={5}>
                  <Grid container spacing={1.5}>
                    {stats.map((item) => (
                      <Grid item xs={12} sm={4} key={item.label}>
                        <MDBox
                          sx={{
                            p: 2,
                            borderRadius: "18px",
                            background: item.accent,
                            border: `1px solid ${colors.grey[200]}`,
                            minHeight: "100%",
                          }}
                        >
                          {item.icon}
                          <MDTypography variant="button" color="text">
                            {item.label}
                          </MDTypography>
                          <MDTypography variant="h6" fontWeight="bold" color="dark">
                            {item.value}
                          </MDTypography>
                        </MDBox>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            </MDBox>*/}

            <Divider />

            <MDBox px={{ xs: 3, md: 4 }} py={{ xs: 3, md: 4 }}>
              <Grid container spacing={2.5} alignItems="end" justifyContent="space-between">
                <Grid item xs={12} lg={8}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        id="month"
                        type="month"
                        value={selectedMonth}
                        defaultValue={selectedMonth}
                        name="Date"
                        label="Select Month"
                        onChange={(event) => {
                          setSelectedMonth(event.target.value);
                        }}
                        sx={fieldSx}
                      />
                    </Grid>
                    <Grid item xs={12} md={5}>
                      <MDBox sx={fieldSx}>
                        <SelectEmployee
                          label="Select Employee"
                          onSelected={(value) => {
                            setSelectedEmployee(value ?? "");
                          }}
                        />
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <MDButton
                        fullWidth
                        variant="outlined"
                        color="info"
                        sx={{ height: "100%", minHeight: 52, borderRadius: "16px" }}
                        onClick={handleFilterSubmit}
                      >
                        Apply Filters
                      </MDButton>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} lg="auto">
                  <MDButton
                    //variant="gradient"
                    color="info"
                    sx={{
                      minHeight: 52,
                      px: 3,
                      borderRadius: "16px",
                      boxShadow: "0 16px 30px rgba(15, 23, 42, 0.18)",
                    }}
                    onClick={() => {
                      setShiftPayload(initialCreatePayload());
                      setSelectedEmployees([]);
                      setEmployeeChecked(false);
                      setMultiDialogOpen(true);
                    }}
                  >
                    Create Shift Assignment
                  </MDButton>
                </Grid>
              </Grid>

              {/*<MDBox
                sx={{
                  mt: 3,
                  p: 2,
                  borderRadius: "20px",
                  border: `1px solid ${colors.grey[200]}`,
                  //background: "#fbfcfe",
                }}
              >*/}
							<div style={{marginTop : "24px"}}>
                <DataTable
                  table={employeeShiftsData}
                  isShiftsTable
                  callableFunction={() => {}}
                />
							</div>
            </MDBox>
          </Card>
        </MDBox>
      </MDBox>

      <Dialog
        PaperProps={{ sx: dialogPaperSx }}
        open={multiDialogOpen}
        onClose={resetCreateDialog}
      >
        <DialogTitle
          sx={{
            px: 3,
            py: 2.5,
            background: `linear-gradient(135deg, ${rgba(colors.primary.main, 0.98)} 0%, ${rgba(colors.info.focus, 0.95)} 55%, ${rgba(colors.info.main, 0.88)} 100%)`,
            color: "white",
          }}
        >
          <MDBox display="flex" alignItems="center" justifyContent="space-between">
            <MDBox>
              <Typography sx={{ color: "White", fontWeight: "medium", fontSize: "1.1rem" }}>
                Create Shift Assignment
              </Typography>
              <Typography sx={{ color: "rgba(255,255,255,0.75)", fontSize: "0.875rem", mt: 0.5 }}>
                Assign a schedule to one or multiple employees.
              </Typography>
            </MDBox>
            <Icon fontSize="medium" onClick={resetCreateDialog}>
              close
            </Icon>
          </MDBox>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <Card
            id="basic-info"
            sx={{
              overflow: "visible",
              //background:
              //  `linear-gradient(135deg, ${rgba(colors.primary.main, 0.98)} 0%, ${rgba(colors.info.focus, 0.95)} 55%, ${rgba(colors.info.main, 0.88)} 100%)`,
              boxShadow: "none",
            }}
          >
            <MDBox component="form" pb={3} px={3} pt={3}>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={4}>
                  <MDBox
                    sx={{
                      p: 2,
                      borderRadius: "18px",
                      background: "rgba(37, 99, 235, 0.08)",
                      border: "1px solid rgba(37, 99, 235, 0.12)",
                    }}
                  >
                    <MDTypography variant="button" color="text">
                      Shift
                    </MDTypography>
                    <MDTypography variant="h6" color="dark" fontWeight="bold">
                      {selectedShiftDetails?.name || "Not selected"}
                    </MDTypography>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={4}>
                  <MDBox
                    sx={{
                      p: 2,
                      borderRadius: "18px",
                      background: "rgba(16, 185, 129, 0.08)",
                      border: "1px solid rgba(16, 185, 129, 0.12)",
                    }}
                  >
                    <MDTypography variant="button" color="text">
                      Employees
                    </MDTypography>
                    <MDTypography variant="h6" color="dark" fontWeight="bold">
                      {selectedEmployeesCount}
                    </MDTypography>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={4}>
                  <MDBox
                    sx={{
                      p: 2,
                      borderRadius: "18px",
                      background: "rgba(245, 158, 11, 0.08)",
                      border: "1px solid rgba(245, 158, 11, 0.12)",
                    }}
                  >
                    <MDTypography variant="button" color="text">
                      Weekly off
                    </MDTypography>
                    <MDTypography variant="h6" color="dark" fontWeight="bold">
                      {shiftPayload?.week_off?.length || 0} selected
                    </MDTypography>
                  </MDBox>
                </Grid>
              </Grid>

              <Grid container spacing={3} justifyContent="center">
                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    id="shifts"
                    options={officeShifts}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        name="Office Shifts"
                        label="Select Office Shift"
                        variant="outlined"
                        required
                        error={!!ShiftError}
                        helperText={ShiftError}
                        sx={fieldSx}
                      />
                    )}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setShiftPayload((state) => ({
                          ...state,
                          shift: newValue.id,
                          shift_hours: newValue.shift_hours,
                          time_from: newValue.time_from,
                        }));
                      }
                      setShiftError("");
                      setShiftHoursError("");
                      setStartTimeError("");
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    type="number"
                    label="Shift Hours"
                    value={shiftPayload.shift_hours || ""}
                    variant="outlined"
                    onChange={() => {
                      setShiftHoursError("");
                    }}
                    required
                    fullWidth
                    error={!!ShiftHoursError}
                    helperText={ShiftHoursError}
                    sx={fieldSx}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Start Time"
                    value={shiftPayload.time_from || ""}
                    variant="outlined"
                    onChange={() => {}}
                    fullWidth
                    required
                    error={!!StartTimeError}
                    helperText={StartTimeError}
                    sx={fieldSx}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Start Date"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        id="start_date"
                        fullWidth
                        type="date"
                        value={shiftPayload.start_date || ""}
                        name="start_date"
                        onChange={(event) => {
                          setShiftPayload((state) => ({
                            ...state,
                            start_date: event.target.value,
                          }));
                          setStartDateError("");
                        }}
                        required
                        error={!!StartDateError}
                        helperText={StartDateError}
                        sx={fieldSx}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="End Date"
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        id="end_date"
                        fullWidth
                        type="date"
                        value={shiftPayload.end_date || ""}
                        name="end_date"
                        onChange={(event) => {
                          setShiftPayload((state) => ({
                            ...state,
                            end_date: event.target.value,
                          }));
                          setEndDateError("");
                        }}
                        required
                        error={!!EndDateError}
                        helperText={EndDateError}
                        sx={fieldSx}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    id="Weekly Off"
                    options={weekList}
                    multiple
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        name="Weekly Off"
                        label="Select Weekly Off"
                        variant="outlined"
                        required
                        error={!!SelectWeeklyOffError}
                        helperText={SelectWeeklyOffError}
                        sx={fieldSx}
                      />
                    )}
                    onChange={(event, newValue) => {
                      setShiftPayload((state) => ({
                        ...state,
                        week_off: Array.isArray(newValue) ? newValue : [newValue],
                      }));
                      setSelectWeeklyOffError("");
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                >
                  <Checkbox
                    checked={employeeChecked}
                    onChange={(event) => {
                      const checked = event.target.checked;
                      setEmployeeChecked(checked);

                      if (checked) {
                        setSelectedEmployees(employees);
                        setShiftPayload((state) => ({
                          ...state,
                          user_ids: employees.map((employee) => employee.id),
                        }));
                      } else {
                        setSelectedEmployees([]);
                        setShiftPayload((state) => ({
                          ...state,
                          user_ids: [],
                        }));
                      }
                    }}
                  />
                  <MDTypography fontWeight="medium">Select All Employees</MDTypography>
                </Grid>

                <Grid item xs={12}>
                  <Autocomplete
                    id="employees"
                    options={employees}
                    multiple
                    value={selectedEmployees}
                    disableCloseOnSelect
                    getOptionLabel={(option) =>
                      `${option.user.firstname} ${option.user.lastname}`
                    }
                    onChange={(event, newValue) => {
                      setSelectedEmployees(newValue);
                      setShiftPayload((state) => ({
                        ...state,
                        user_ids: newValue.map((value) => value.id),
                      }));
                      setEmployeeChecked(newValue.length === employees.length);
                      setSelectEmployeError("");
                    }}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox style={{ marginRight: 8 }} checked={selected} />
                        {option.user.firstname} {option.user.lastname}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Employee"
                        variant="outlined"
                        error={!!SelectEmployeError}
                        helperText={SelectEmployeError}
                        sx={fieldSx}
                      />
                    )}
                  />
                </Grid>
              </Grid>

              <MDBox
                mt={3}
                pt={2.5}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                flexWrap="wrap"
                gap={1.5}
                borderTop={`1px solid ${colors.grey[200]}`}
              >
                <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                  {(shiftPayload?.week_off || []).map((day) => (
                    <Chip
                      key={day}
                      label={day}
                      size="small"
                      sx={{
                        background: "rgba(37, 99, 235, 0.08)",
                        color: colors.info.main,
                        fontWeight: 600,
                      }}
                    />
                  ))}
                </Stack>
                <MDButton
                  variant="gradient"
                  color="info"
                  sx={{ borderRadius: "14px", px: 4 }}
                  onClick={handleSubmit}
                >
                  Save Shift Assignment
                </MDButton>
              </MDBox>
            </MDBox>
          </Card>
        </DialogContent>
      </Dialog>

      <Dialog
        PaperProps={{ sx: dialogPaperSx }}
        open={editDialog}
        onClose={() => {
          setEditDialog(false);
        }}
      >
        <DialogTitle
          sx={{
            px: 3,
            py: 2.5,
            //background: "linear-gradient(135deg, #0f172a 0%, #2563eb 100%)",
						background:
                `linear-gradient(135deg, ${rgba(colors.primary.main, 0.98)} 0%, ${rgba(colors.info.focus, 0.95)} 55%, ${rgba(colors.info.main, 0.88)} 100%)`,
            color: "white",
          }}
        >
          <MDBox display="flex" alignItems="center" justifyContent="space-between">
            <MDBox>
              <Typography sx={{ color: "White", fontWeight: "medium", fontSize: "1.1rem" }}>
                Edit Shift
              </Typography>
              <Typography sx={{ color: "rgba(255,255,255,0.75)", fontSize: "0.875rem", mt: 0.5 }}>
                Update the assigned shift and work mode for this day.
              </Typography>
            </MDBox>
            <Icon
              fontSize="medium"
              onClick={() => {
                setEditDialog(false);
              }}
            >
              close
            </Icon>
          </MDBox>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <Card
            id="basic-info"
            sx={{
              overflow: "visible",
              background:
                "linear-gradient(180deg, rgba(248, 250, 252, 1) 0%, rgba(255, 255, 255, 1) 100%)",
              boxShadow: "none",
            }}
          >
            <MDBox component="form" pb={3} px={3} pt={3}>
              <Grid container spacing={2} sx={{ mb: 1 }}>
                <Grid item xs={12} md={6}>
                  <MDBox
                    sx={{
                      p: 2,
                      borderRadius: "18px",
                      background: "rgba(37, 99, 235, 0.08)",
                      border: "1px solid rgba(37, 99, 235, 0.12)",
                    }}
                  >
                    <MDTypography variant="button" color="text">
                      Selected shift
                    </MDTypography>
                    <MDTypography variant="h6" color="dark" fontWeight="bold">
                      {editShiftDetails?.name || "Not selected"}
                    </MDTypography>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={6}>
                  <MDBox
                    sx={{
                      p: 2,
                      borderRadius: "18px",
                      background: editPayloadData?.is_wfh
                        ? "rgba(16, 185, 129, 0.08)"
                        : "rgba(15, 23, 42, 0.05)",
                      border: editPayloadData?.is_wfh
                        ? "1px solid rgba(16, 185, 129, 0.12)"
                        : `1px solid ${colors.grey[200]}`,
											marginBottom : "20px"
                    }}
                  >
                    <MDTypography variant="button" color="text">
                      Work mode
                    </MDTypography>
                    <MDTypography variant="h6" color="dark" fontWeight="bold">
                      {editPayloadData?.is_wfh ? "Work From Home" : "Office Shift"}
                    </MDTypography>
                  </MDBox>
                </Grid>
              </Grid>

              <Grid container spacing={3} justifyContent="center" alignItems="flex-end">
                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    id="edit-shifts"
                    options={officeShifts}
                    value={officeShifts.find((entry) => entry.id == editPayloadData.shift) || null}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        name="Office Shifts"
                        label="Select Office Shift"
                        variant="outlined"
                        required
                        error={!!ShiftError}
                        helperText={ShiftError}
                        sx={fieldSx}
                      />
                    )}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setEditPayloadData((state) => ({
                          ...state,
                          shift: newValue.id,
                          shift_hours: newValue.shift_hours,
                          time_from: newValue.time_from,
                        }));
                      }
                      setShiftError("");
                      setShiftHoursError("");
                      setStartTimeError("");
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    type="number"
                    label="Shift Hours"
                    value={editShiftDetails?.shift_hours || ""}
                    variant="outlined"
                    onChange={() => {
                      setShiftHoursError("");
                    }}
                    required
                    fullWidth
                    error={!!ShiftHoursError}
                    helperText={ShiftHoursError}
                    sx={fieldSx}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Start Time"
                    value={editShiftDetails?.time_from || ""}
                    variant="outlined"
                    onChange={() => {}}
                    fullWidth
                    required
                    error={!!StartTimeError}
                    helperText={StartTimeError}
                    sx={fieldSx}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  {/*<MDBox
                    sx={{
                      p: 1,
                      borderRadius: "16px",
                      border: `1px solid ${colors.grey[200]}`,
                      //background: "#fbfcfe",
                    }}
                  >*/}
                    <Checkbox
                      checked={editPayloadData?.is_wfh || false}
                      size="small"
                      style={{ width: "20px", padding: 0, paddingRight: 20 }}
                      onChange={(e) => {
												const checked = e.target.checked;
                        setEditPayloadData((state) => ({
                          ...state,
                          is_wfh: checked,
													//tracking_method: checked ? (state.tracking_method ?? 0) : null, // reset tracking method if unchecked	

                        }));
                      }}
                    />
                    <MDTypography component="span" fontWeight="medium">
                      Is WFH
                    </MDTypography>
                  {/*</MDBox>*/}
								</Grid>
								{/*{editPayloadData?.is_wfh && (
									<Grid item xs={12} sm={12} md={12} >
										<TextField
											select
											label="Tracking Method"
											fullWidth
											value={editPayloadData.tracking_method ?? 0}
											onChange={(e) => {
												setEditPayloadData((state) => ({
													...state,
													tracking_method: Number(e.target.value),
												}));
											}}
											SelectProps={{ native: true }}
										>
											<option value={0}>Not Required</option>
											<option value={1}>By App</option>
										</TextField>
									</Grid>
								)}*/}
                {/* <Grid item xs={12} sm={6}>
                  <Autocomplete
                    id="Weekly Off"
                    options={weekList}
                    multiple
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        name="Weekly Off"
                        label="Select Weekly Off"
                        variant="standard"
                        required
                        error={!!SelectWeeklyOffError}
                        helperText={SelectWeeklyOffError}
                      />
                    )}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        const selectedValues = Array.isArray(newValue)
                          ? newValue.map((v) => v)
                          : [newValue];

                        // setNewRecord((state) => ({
                        //   ...state,
                        //   recruiter: selectedValues,
                        // }));
                        setShiftPayload((state) => ({
                          ...state,
                          week_off: selectedValues,
                        }));
                      }
                      setSelectWeeklyOffError("");
                    }}
                  />
                </Grid> */}
              </Grid>

              <MDBox
                mt={3}
                pt={2.5}
                display="flex"
                justifyContent="flex-end"
                borderTop={`1px solid ${colors.grey[200]}`}
              >
                <MDButton
                  variant="gradient"
                  color="info"
                  sx={{ borderRadius: "14px", px: 4 }}
                  onClick={updateEmployeeShift}
                >
                  Update Shift
                </MDButton>
              </MDBox>
            </MDBox>
          </Card>
        </DialogContent>
      </Dialog>

    </DashboardLayout>
  );
}

export default Shifts;
